import { Injectable, Injector } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { VolunteeringApplicant } from '../browse-projects-module/models/volunteering-application.model';
import { HeaderService } from './header.service';
import {  Observable, Subject } from 'rxjs';
import { MainVolunteeringResponse } from '../shared/projects.model';
import { User } from '../shared/user.model';

@Injectable({
  providedIn: 'root'
})
export class VolunteeringService {

  userMissionsUpdated$ = new Subject<void>();

  constructor(private apiService: ApiService,
              private injector: Injector) {

  }

  getIndividualMission(missionId: number | string) {
    return this.apiService.getIndividualMission(missionId);
  }

  getAllMissions(): Observable<any> {
    const headerService = this.injector.get(HeaderService);
    return this.apiService.getMainVolunteeringInfo().pipe(
      tap((response: MainVolunteeringResponse) => {
        if (!response.volunteering_onboarding) {
          headerService.$isVolunteeringOnboardingDone.next(false);
        }
      })
    );
  }


  getProjectVolunteering(projectId: number) {
    return this.apiService.getProjectVolunteeringOffers(projectId)
      .pipe(
        map(response => response.results),
      );
  }

  addApplicantProjectVolunteering(applicant: VolunteeringApplicant) {
    return this.apiService.newApplicantVolunteeringProject(applicant)
      .pipe(
        tap(() => this.userMissionsUpdated$.next()),
        map(response => response.results)
      );
  }

  getUserAppliedProjects(email: string) {
    return this.apiService.getAccountVolunteeringApplications(email);
  }

  shareVolunteeringOffer(userId: number, userMessage: string, missionId: number, recipientsIds: string, missionType: string) {
    return this.apiService.postShareVolunteeringOffer(userId, userMessage, missionId, recipientsIds, missionType);
  }

  getCollectiveActivity(activityId: number | string) {
    return this.apiService.getCollectiveActivity(activityId);
  }

  getTeamBuilding(teamBuildingId: number | string) {
    return this.apiService.getTeamBuilding(teamBuildingId);
  }

  sendFeedback(feedback: any) {
    return this.apiService.sendVolunteeringFeedback(feedback);
  }

  uploadActivityPicture(picture: File): Observable<any> {
    return this.apiService.postLacChallengePictureUpload( picture);
  }

  sendActivityProposal(proposal: any) {
    return this.apiService.sendActivityProposal(proposal);
  }

  signUpCollectiveActivity(application: any) {
    return this.apiService.signUpCollectiveActivity(application);
  }

  signUpTeamBuilding(application: any) {
    return this.apiService.signUpTeamBuilding(application);
  }

  signUpOffer(application: any) {
    return this.apiService.signUpOffer(application);
  }

  cancelOfferRegistration(data: any) {
    return this.apiService.cancelOfferRegistration(data);
  }

  cancelActivityRegistration(data: any) {
    return this.apiService.cancelActivityRegistration(data);
  }

  cancelTeamBuildingRegistration(data: any) {
    return this.apiService.cancelTeamBuildingRegistration(data);
  }

  updateCollectiveActivity(data: any) {
    return this.apiService.updateCollectiveActivity(data);
  }

  deleteCollectiveActivity(user: User, activityId: number) {
    return this.apiService.deleteCollectiveActivity(user, activityId);
  }
}
